
import React from 'react';
import Col from '@visa/vds/col';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Typography from '@visa/vds/typography';
import '../../Style/Store.css';
import { ProductSelectionConst } from '../SelectProduct/ProductSelectionLogic';
import VSTSDateSelectorComponent from './VSTSDateSelectorComponent';


const VSTSSubscriptionDetails = (props) => {
    return (
        <>
        <Grid type="fluid">
            <Row className="product-details-row">
                <Col className="product-name-col">
                    <Typography tag="h2">Visa Secure Test Suite (VSTS)</Typography>
                        {props.selectedProductInfo && props.selectedProductInfo == ProductSelectionConst.BASE_SUBSCRIPTION &&
                            <Row>
                                <Typography tag="h4"><b>Selected Subscription: </b>Base Subscription: 90 Calendar Day Access</Typography>
                                <VSTSDateSelectorComponent setSelectedVSTSStartDate={props.setSelectedVSTSStartDate} 
                                    setSelectedVSTSEndDate={props.setSelectedVSTSEndDate} setShowVSTSStartDateError={props.setShowVSTSStartDateError}
                                    showVSTSStartDateError={props.showVSTSStartDateError}
                                    selectedVSTSStartDate={props.selectedVSTSStartDate} selectedVSTSEndDate={props.selectedVSTSEndDate}
                                    duration={90} errorText={props.errorText} setErrorText={props.setErrorText}
                                    currentVstsSubscriptionEndDate={props.currentVstsSubscriptionEndDate}/>
                            </Row>
                        }
                        {props.selectedProductInfo && props.selectedProductInfo == ProductSelectionConst.EXTENSION_SUBSCRIPTION &&
                            <Row>
                                <Typography tag="h4">Extend Subscription: 30 Calendar Day Access</Typography>                                                                
                                <VSTSDateSelectorComponent setSelectedVSTSStartDate={props.setSelectedVSTSStartDate}
                                    setSelectedVSTSEndDate={props.setSelectedVSTSEndDate} setShowVSTSStartDateError={props.setShowVSTSStartDateError}
                                    showVSTSStartDateError={props. showVSTSStartDateError}
                                    selectedVSTSStartDate={props.selectedVSTSStartDate} selectedVSTSEndDate={props.selectedVSTSEndDate}
                                    duration={30} errorText={props.errorText} setErrorText={props.setErrorText}
                                    currentVstsSubscriptionEndDate={props.currentVstsSubscriptionEndDate}/>
                            </Row>
                        }
                </Col>
            </Row>
            </Grid>
        </>
    );
}

export default VSTSSubscriptionDetails